import React, { useEffect, useState } from "react";
import {
  Label,
  Dropdown,
  Input,
  Button,
  Switch,
  Option,
  Field,
  Spinner
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import {
  ChevronUp16Regular,
  ChevronDown16Regular,
} from "@fluentui/react-icons";

import "../CSS/AgentForm.css";

import SearchResourceInGraph from "../GenericComponent/SearchResourceInGraph";
import InfoButton from "../GenericComponent/InfoButton";


const AgentForm = (props) => {
  const [showAdvanced, setShowAdvanced] = useState(true);
  const [licences, setLicences] = useState([]);
  const availableLicences = props.SCOPE_AVAILABLE_LICENCES || {};
  const scopeList = Object.keys(availableLicences);
  const [selectedLicence, setSelectedLicence] = useState("");
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    if (!props.agent) return;
    
    const newErrors = {};

    if (!props.agent.displayName)
      newErrors.displayName = t("THIS_FIELD_IS_REQUIRED");
    if (!props.agent.scope) newErrors.scope = t("THIS_FIELD_IS_REQUIRED");
    if (!props.agent.licenceLevel)
      newErrors.licenceLevel = t("THIS_FIELD_IS_REQUIRED");

    setErrors(newErrors);

    // Retourne true si aucun champ vide
    const isValid = Object.keys(newErrors).length === 0;
    if (props.setFormValid) props.setFormValid(isValid); // on remonte l'état au parent
  };
  useEffect(() => {
    if (props.agent) {
      validateForm();
    }
  }, [props.agent?.displayName, props.agent?.scope, props.agent?.licenceLevel]);

  //  Ouvre automatiquement la section avancée en mode update si la licence est CX_ELEVATE / CX_EXPERIENCE
  useEffect(() => {
    if (!props.agent) return;
    
    console.log("Agent récupéré:", props.agent);
    console.log("Agent Profile ID:", props.agent.agentProfileId);
    console.log("All Agents Profiles:", props.agentsProfiles);
    
    if (
      props.isUpdate &&
      (props.agent.licenceLevel === "CX_ELEVATE" ||
        props.agent.licenceLevel === "CX_EXPERIENCE")
    ) {
      setShowAdvanced(true);
      setSelectedLicence(props.agent.licenceLevel);
    }
  }, [props.isUpdate, props.agent?.licenceLevel, props.agent?.agentProfileId]);

  // Trouver le displayName du profil à partir de l'ID
  const getAgentProfileDisplayName = () => {
    if (!props.agent?.agentProfileId || !props.agentsProfiles) return '';
    
    const profile = Object.values(props.agentsProfiles).find(
      p => p.id === props.agent.agentProfileId
    );
    console.log("Selected Profile:", profile);
    return profile?.displayName || '';
  };

  const handleAgentProfileSelect = (e, data) => {
    console.log("Profile selected:", data.optionValue);
    console.log("Profile ID:", data.optionValue.id);
    
    // data.optionValue contient maintenant l'objet complet du profil
    props.setAgent((agent) => ({
      ...agent,
      agentProfileId: data.optionValue.id,
    }));
  }
  //  Quand on change la licence manuellement
  const handleLicenceSelect = (_, data) => {
    const licence = data.optionValue;
    setSelectedLicence(licence);

    props.setAgent((agent) => ({
      ...agent,
      licenceLevel: licence,
    }));

    // Ouvre ou ferme automatiquement la section avancée selon la licence
    if (licence === "CX_ELEVATE" || licence === "CX_EXPERIENCE") {
      setShowAdvanced(true);
    } else {
      setShowAdvanced(false);
    }
  };
  // Mettre à jour la liste des licences selon le scope sélectionné
  useEffect(() => {
  const selectedScope = props.agent.scope;

  if (selectedScope && availableLicences[selectedScope]) {
    const scopeLicences = Object.keys(availableLicences[selectedScope])
      .filter(
        (key) => key !== "PartitionKey" && 
                 key !== "RowKey" && 
                 !key.startsWith("USED_") && 
                 !key.startsWith("AVAILABLE_")
      );

    
    setLicences(scopeLicences);
    setSelectedLicence("");
  } else {
    setLicences([]);
    setSelectedLicence("");
  }
}, [props.agent.scope, availableLicences]);


  const addContact = (contact) => {
    if (contact.header && contact.id && contact.email) {
      props.setAgent({
        ...props.agent,
        displayName: contact.header,
        id: contact.id,
        RowKey: contact.id,
        email: contact.email,
      });
    }
  };
  return (
    <>
      {
        props.agent ?
          <div className="agent-form-root">
            {/* FORMULAIRE PRINCIPAL  <Label weight="semibold">{t("AGENT_NAME")}</Label>*/}
            <div className="agent-form-group ">
              <Field
                label={t("AGENT_NAME")}
                className="agent-form-field "
                required 
                validationState={errors.displayName ? "error" : "none"}
                validationMessage={errors.displayName}
              >
                {
                  props.isUpdate ? (
                    <Input
                    className="agent-form-update"
                    
                      value={props.agent.displayName || ""}
                      disabled
                    />
                  ) :  <SearchResourceInGraph
                   displayName={props.agent.displayName || ""} // ensure not undefined
                  onSelectUser={(user) => {
                    addContact(user);
                    props.setAgent({
                      ...props.agent,
                      displayName: user.displayName,
                      id: user.id,
                      RowKey: user.id,
                      email: user.email,
                    });
                  }}
                  isUpdate={props.isUpdate}
                />
                }
               
              </Field>
            </div>

            <div className="agent-form-group">
              <Field
                label={t("SCOPE")}
                className="agent-form-field "
                required
                validationState={errors.scope ? "error" : "none"}
                validationMessage={errors.scope}
              >
                <Dropdown
                  clearable
                  className="agent-form-dropdown"
                  placeholder={t("SELECT_SCOPE")}
                  value={props.agent.scope}
                  disabled={props.isUpdate === true}
                  onOptionSelect={(_, data) => {
                    props.setAgent((agent) => ({
                      ...agent,
                      scope: data.optionValue,
                      licenceLevel: "",
                    }));
                  }}
                >
                  {scopeList.map((scope, index) => (
                    <Option key={index} value={scope}>
                      {scope}
                    </Option>
                  ))}
                </Dropdown>
              </Field>
            </div>

            <div className="agent-form-group">
         {props.permissions?.License?.canRead && (
  <Field
                className="agent-form-field "
                label={t("LICENCE_LEVEL")}
                required
                validationState={errors.licenceLevel ? "error" : "none"}
                validationMessage={errors.licenceLevel}
              >
                <Dropdown
                  value={t(props.agent.licenceLevel)}
                  className="agent-form-dropdown"
                  placeholder={t("SELECT_LICENCE")}
                  selectedOptions={[selectedLicence]}
                  onOptionSelect={handleLicenceSelect}
                  disabled={
                    licences.length === 0 ||
                    
                    (props.isUpdate ? !props.permissions?.License?.canUpdate : !props.permissions?.License?.canCreate)
                  }
                >
                  {licences.length > 0 ? (
                    licences.map((licence, index) => (
                      <Option key={index} value={licence}>
                        {t(licence)}
                      </Option>
                    ))
                  ) : (
                    <Option disabled>{t("AUCUN_LICENCE")}</Option>
                  )}
                </Dropdown>
              </Field>
         )}   
            </div>

            {(selectedLicence === "CX_ELEVATE" ||
              selectedLicence === "CX_EXPERIENCE" ||
              props.agent.licenceLevel === "CX_ELEVATE" ||
              props.agent.licenceLevel === "CX_EXPERIENCE") && (
                <>
                  <div className="agent-form-header-row">
                    <Button
                      appearance="subtle"
                      size="small"
                      icon={
                        showAdvanced ? <ChevronDown16Regular /> : <ChevronUp16Regular />
                      }
                      onClick={() => setShowAdvanced(!showAdvanced)}
                    >
                      <Label weight="semibold">{t("ADVANCED")}</Label>
                    </Button>
                    <InfoButton infoKey="ADVANCED" category="AGENTS" />
                  </div>

                  <div className={`agent-form-advanced-content ${showAdvanced ? "open" : ""}`}>
                    <div className="agent-form-checkbox-row">
                      <Label weight="semibold">
                        {t("ENABLE_AUDIO")}
                        <InfoButton infoKey="ENABLE_AUDIO" category="AGENTS" />
                      </Label>
                      <Switch
                        checked={props.agent.enableCallRecording || false}
                        onChange={(e, data) => {
                          props.setAgent({
                            ...props.agent,
                            enableCallRecording: data.checked,
                            callRecordingScope:
                              data.checked === false
                                ? t("NULL")
                                : props.agent.callRecordingScope,
                          });
                        }}
                      />
                    </div>

                    <div className="agent-form-checkbox-row">
                      <Label weight="semibold">
                        {t("ENABLE_CALL_REPORTING")}
                        <InfoButton infoKey="ENABLE_CALL_REPORTING" category="AGENTS" />
                      </Label>
                      <Switch
                        checked={props.agent.enableAllCallsReporting || false}
                        onChange={(_, data) => {
                          props.setAgent((prev) => ({
                            ...prev,
                            enableAllCallsReporting: data.checked,
                          }));
                        }}
                      />
                    </div>

                    <div className="agent-form-input-row-container">
                      <Label weight="semibold">
                        {t("SAVE_CALL")}
                        <InfoButton infoKey="SAVE_CALL" category="AGENTS" />
                      </Label>
                      <Dropdown
                        clearable
                        className="agent-form-dropdown-row"
                        value={
                          props.agent.callRecordingScope &&
                            props.agent.callRecordingScope !== null ? (
                            props.agent.callRecordingScope
                          ) : (
                            <span>{t("NULL")}</span>
                          )
                        }
                        onOptionSelect={(_, data) => {
                          props.setAgent({
                            ...props.agent,
                            callRecordingScope: data.optionValue,
                          });
                        }}
                      >
                        <Option value="ALL">{t("ALL")}</Option>
                        <Option value="FLOW_CALLS_ONLY">{t("FLOW_CALLS_ONLY")}</Option>
                        <Option value="P2P">{t("P2P")}</Option>
                        <Option value="PSTN">{t("PSTN")}</Option>
                      </Dropdown>
                    </div>

                    <div className="agent-form-input-row-container">
                      <Label weight="semibold">
                        {t("WEBHOOK_AFTER_SAVE")}
                        <InfoButton infoKey="WEBHOOK_AFTER_SAVE" category="AGENTS" />
                      </Label>
                      <Input
                        className="agent-form-input-row"
                        value={props.agent.recordingWebhook || ""}
                        onChange={(event, data) => {
                          props.setAgent({
                            ...props.agent,
                            recordingWebhook: data.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            <div className="agent-form-group">
            {  props.permissions?.Profile?.canRead && ( <Field
                className="agent-form-field "
                label={
                  <>
                    {t("AGENT_PROFILE")}
                    <InfoButton infoKey="AGENT_PROFILE" category="AGENTS" />
                  </>
                }
              >
                <Dropdown
                  value={getAgentProfileDisplayName()}
                  className="agent-form-dropdown"
                  placeholder={t("SELECT_AGENT_PROFILE")}
                  onOptionSelect={handleAgentProfileSelect}
                  disabled={
                  
                    (props.isUpdate ? !props.permissions?.Profile?.canUpdate : !props.permissions?.Profile?.canCreate)
                  }
                >
                  {props.agentsProfiles && Object.values(props.agentsProfiles).length > 0 ? (
                    Object.values(props.agentsProfiles).map((agentProfile, index) => (
                      <Option key={index} value={agentProfile}>
                        {agentProfile.displayName}
                      </Option>
                    ))
                  ) : (
                    <Option disabled>{t("AUCUN_AGENT_PROFILE")}</Option>
                  )}
                </Dropdown>

              </Field>)} 
            </div>
          </div>
          :
          <Spinner />
      }
    </>


  );
};

export default AgentForm;
